// extracted by mini-css-extract-plugin
export default {"root":"VerifiedFilter_root__cKzC4","divider":"VerifiedFilter_divider__8ONQt","title":"VerifiedFilter_title__r-YRz","verified":"VerifiedFilter_verified__ZZpl6"};